import Highcharts from 'highcharts';
import { filterByCategory } from "../ranking-sm/data.js";

function getClosureRateData() {
    const categories = [
        'Czas reakcji: liczba zgłoszeń',
        'Czas reakcji: liczba zamkniętych'
    ];
    const data = filterByCategory(categories);

    data.forEach(sm => {
        sm.closureRate = Math.round((sm['Czas reakcji: liczba zamkniętych'] / sm['Czas reakcji: liczba zgłoszeń']) * 100 * 10) / 10;
        sm.totalReports = sm['Czas reakcji: liczba zgłoszeń'];
        sm.closedReports = sm['Czas reakcji: liczba zamkniętych'];
    });

    return data.sort((a, b) => b.closureRate - a.closureRate);
}

export default function chartClosureRate(id) {
    if (!document.getElementById(id)) return;

    const data = getClosureRateData();
    const categories = data.map(item => item.city);
    const closureRate = data.map(item => item.closureRate);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Ratio of closed to total reports' },
        subtitle: { text: 'Based on reports from the Uprzejmie Donoszę app (2024–2025)' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: 'Percent' },
            min: 0
        },
        legend: { enabled: false },
        tooltip: { shared: true },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: { enabled: true, format: '{y}%' }
            }
        },
        credits: { enabled: false },
        series: [{
            name: '% of closed reports',
            data: closureRate,
            color: '#3498db'
        }]
    });
}
